export default {
  // Navbar
  'nav.home': 'Начало',
  'nav.about': 'За нас',
  'nav.services': 'Услуги',
  'nav.contracts': 'Договори',
  'nav.profit': 'Печалба',
  'nav.video': 'Видео',
  'nav.invest': 'ИНВЕСТИРАЙ',

  // Hero
  'hero.badge': 'Elon Musk · SpaceX · IPO 2025',
  'hero.title1': 'ИНВЕСТИРАЙТЕ В',
  'hero.title2': 'БЪДЕЩЕТО',
  'hero.desc': 'Ексклузивни инвестиционни договори в рамките на IPO на SpaceX от Илон Мъск. Доходност от <strong>20% до 50%</strong> само за <strong>2 работни дни</strong>. Договори от <strong>3 000 €</strong>.',
  'hero.cta.primary': 'ИЗБЕРЕТЕ ДОГОВОР',
  'hero.cta.secondary': 'Научете повече',
  'hero.stat1': 'Макс. доходност',
  'hero.stat2': 'Топ договор',
  'hero.stat3': 'Година на IPO',

  // About
  'about.tag': 'За SpaceX IPO',
  'about.title1': 'КОМПАНИЯ НА',
  'about.title2': 'БЪДЕЩЕТО',
  'about.p1': 'SpaceX е аерокосмическа компания на Илон Мъск, която промени индустрията на космическите полети. Първата частна компания, доставила астронавти на МКС, създател на Starlink и разработчик на Starship.',
  'about.p2': 'IPO на SpaceX е историческо събитие, което открива уникална възможност да станете акционер на компания, оценена на повече от <strong>$200 милиарда</strong>. Нашите пакети позволяват да влезете с минимален праг и гарантирана печалба само за <strong>2 работни дни</strong>.',
  'about.fact1': 'Оценка на SpaceX',
  'about.fact2': 'Успешни изстрелвания',
  'about.fact3': 'Starlink сателити',
  'about.fact4': 'Инвеститори по света',
  'about.badge': 'Оценка на компанията',

  // Services
  'services.tag': 'Какво предлагаме',
  'services.title1': 'НАШИТЕ',
  'services.title2': 'УСЛУГИ',
  'services.sub': 'Пълен спектър от услуги за комфортно и сигурно инвестиране в IPO на SpaceX',
  'services.s1.title': 'Управление на портфейл',
  'services.s1.desc': 'Професионално управление на вашия инвестиционен портфейл. Постоянен мониторинг и оптимизация.',
  'services.s2.title': 'Юридическа защита',
  'services.s2.desc': 'Всички договори са юридически оформени и защитени. Прозрачни условия, без скрити комисионни.',
  'services.s3.title': 'Аналитика и прогнози',
  'services.s3.desc': 'Седмични отчети за портфейла. Анализ на пазара и препоръки от експерти.',
  'services.s4.title': 'Личен мениджър',
  'services.s4.desc': 'Личен мениджър през целия период. На разположение 24/7 за консултации.',
  'services.s5.title': 'Застраховка на средства',
  'services.s5.desc': 'Вашите инвестиции са застраховани. Гарантирана защита на капитала.',
  'services.s6.title': 'Бързо изтегляне',
  'services.s6.desc': 'Получаване на печалба в срок от 1 работен ден. Изтегляне на банкова сметка или крипто портфейл.',

  // Contracts
  'contracts.tag': 'Инвестиционни пакети',
  'contracts.title1': 'ИЗБЕРЕТЕ',
  'contracts.title2': 'ДОГОВОР',
  'contracts.sub': 'Три нива на участие в IPO на SpaceX. Изберете пакет, съответстващ на вашите цели',
  'contracts.duration': '2 работни дни',
  'contracts.profitlabel': 'Доходност',
  'contracts.pure': 'чиста печалба',
  'contracts.btn': 'ИЗБЕРИ ПАКЕТ',
  'contracts.disclaimer': '* Доходността е за 2 работни дни. Всички договори са юридически оформени. Инвестициите се застраховат.',
  'contracts.popular': 'Популярен',
  'contracts.starter.f1': 'Минимален входен праг',
  'contracts.starter.f2': 'Гарантирана доходност 20%',
  'contracts.starter.f3': 'Незабавни изплащания',
  'contracts.starter.f4': 'Личен мениджър',
  'contracts.starter.f5': 'Юридическо оформление',
  'contracts.starter.f6': 'Седмични отчети',
  'contracts.advanced.f1': 'Оптимално съотношение риск/доход',
  'contracts.advanced.f2': 'Гарантирана доходност 30%',
  'contracts.advanced.f3': 'Незабавни изплащания',
  'contracts.advanced.f4': 'VIP личен мениджър',
  'contracts.advanced.f5': 'Разширено юр. съпровождане',
  'contracts.advanced.f6': 'Анализ на пазара в реално време',
  'contracts.advanced.f7': 'Застраховка на инвестиции',
  'contracts.premium.f1': 'Максимална доходност',
  'contracts.premium.f2': 'Гарантирана доходност 50%',
  'contracts.premium.f3': 'Незабавни изплащания',
  'contracts.premium.f4': 'Dedicated мениджър 24/7',
  'contracts.premium.f5': 'Пълно юр. и данъчно съпровождане',
  'contracts.premium.f6': 'Приоритетен достъп до нови пакети',
  'contracts.premium.f7': 'Застраховка + гаранция за връщане',
  'contracts.premium.f8': 'Ексклузивни IPO инсайти',

  // Profit
  'profit.tag': 'Финансови резултати',
  'profit.title1': 'ВАШАТА',
  'profit.title2': 'ПЕЧАЛБА',
  'profit.sub': 'Вижте как растат вашите инвестиции само за 2 работни дни',
  'profit.calc.title': 'КАЛКУЛАТОР НА ПЕЧАЛБА',
  'profit.calc.invested': 'Инвестирано',
  'profit.calc.profit': 'Печалба',
  'profit.calc.total': 'Общо',
  'profit.chart.title': 'ДИНАМИКА НА РАСТЕЖА',
  'profit.chart.sub': 'Прогноза за всички пакети, 2 работни дни',
  'profit.max.title': 'МАКСИМАЛНА ПЕЧАЛБА',
  'profit.max.sub': 'при пакет Premium 10 000 €',

  // Footer
  'footer.nav': 'НАВИГАЦИЯ',
  'footer.legal': 'ПРАВНА ИНФОРМАЦИЯ',
  'footer.desc': 'Ексклузивна възможност за инвестиране в IPO на SpaceX. Присъединете се с гарантирана доходност от 20% до 50% само за 2 работни дни.',
  'footer.terms': 'Условия за ползване',
  'footer.privacy': 'Политика за поверителност',
  'footer.tax': 'Данъчна информация',
  'footer.copy': '© 2025 SpaceX IPO. Всички права запазени.',
  'footer.disclaimer': 'Инвестициите носят риск. Миналата възвръщаемост не гарантира бъдещи резултати.',

  // Live toast
  'toast.earned': 'спечели',
  'toast.in': 'за',
  'toast.days': '2 работни дни',

  // Video section
  'video.tag': 'Космически новини',
  'video.title1': 'ЛУННА МИСИЯ',
  'video.title2': 'НА NASA',
  'video.sub': 'NASA стартира първата пилотирана лунна мисия от половин век насам — ново начало в космическото изследване',
  'video.source': 'Euronews България',
  'video.headline1': 'НАСА изпрати астронавти към Луната с мисията „Артемида 2"',
  'video.date1': 'Euronews България · Април 2026',
  'video.headline2': '„Артемис 2" ще лети до Луната за 10-дневна обиколка',
  'video.date2': 'Euronews България · Април 2026',
  'video.headline3': 'NASA стартира първата пилотирана лунна мисия от половин век насам',
  'video.date3': 'Darik News · Април 2026',
  'video.readmore': 'Прочети статията в Darik News',
  'video.card1': 'SpaceX Starship — ракетата, задвижваща новата лунна мисия',
  'video.card2': 'Първо пилотирано кацане на Луната от Apollo 17 насам (1972)',
  'video.card3': 'Историческото IPO на SpaceX е пряко свързано с успеха на лунната програма',
};